<template>
  <div v-if="!passwordChanged">
    <b-form @submit.prevent="onSubmit">
      <div class="d-flex profile_info_label">
        <div class="label">Текущий пароль:</div>
        <div class="flex-grow-1">
          <b-input-group size="sm">
            <b-form-input 
              v-model="form.current_password" 
              :type="showCurrentPassword ? 'text' : 'password'"
              required
              :disabled="loading"
              placeholder="Введите текущий пароль"
              size="sm"
            ></b-form-input>
            <b-input-group-append
              @click="showCurrentPassword = !showCurrentPassword"
              class="cursor-pointer"
              is-text
            >
              <b-icon scale="1" variant="secondary" :icon="showCurrentPassword ? 'eye' : 'eye-slash'"></b-icon>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

      <div class="d-flex profile_info_label mt-2">
        <div class="label">Новый пароль:</div>
        <div class="flex-grow-1">
          <b-input-group size="sm">
            <b-form-input 
              v-model="form.password" 
              :type="showNewPassword ? 'text' : 'password'"
              required
              :disabled="loading"
              placeholder="Введите новый пароль"
              size="sm"
            ></b-form-input>
            <b-input-group-append
              @click="showNewPassword = !showNewPassword"
              class="cursor-pointer"
              is-text
            >
              <b-icon scale="1" variant="secondary" :icon="showNewPassword ? 'eye' : 'eye-slash'"></b-icon>
            </b-input-group-append>
          </b-input-group>
          <small class="form-text text-muted">
            Минимум 8 символов
          </small>
        </div>
      </div>

      <div class="d-flex profile_info_label mt-2">
        <div class="label">Подтверждение:</div>
        <div class="flex-grow-1">
          <b-input-group size="sm">
            <b-form-input 
              v-model="form.password_confirmation" 
              :type="showConfirmPassword ? 'text' : 'password'"
              required
              :disabled="loading"
              placeholder="Подтвердите новый пароль"
              size="sm"
            ></b-form-input>
            <b-input-group-append
              @click="showConfirmPassword = !showConfirmPassword"
              class="cursor-pointer"
              is-text
            >
              <b-icon scale="1" variant="secondary" :icon="showConfirmPassword ? 'eye' : 'eye-slash'"></b-icon>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

      <div class="text-right mt-3">
        <b-button
          type="submit"
          variant="primary"
          size="sm"
          :disabled="!isFormValid || loading"
        >
          <b-spinner small v-if="loading" class="mr-1"></b-spinner>
          <span v-if="loading">Изменение пароля...</span>
          <span v-else>Изменить пароль</span>
        </b-button>
        
        <b-button 
          type="button" 
          variant="secondary"
          size="sm"
          @click="cancelForm"
          :disabled="loading"
          class="ml-2"
        >
          Отмена
        </b-button>
      </div>
    </b-form>
  </div>

  <div v-else class="text-center">
    <div class="mb-2">
      <b-icon icon="check-circle-fill" variant="success" font-scale="2"></b-icon>
    </div>
    <h6 class="text-success mb-2">Пароль изменен!</h6>
    <p class="text-muted small mb-3">
      Пароль успешно обновлен.
    </p>
    <b-button 
      @click="resetForm"
      variant="primary"
      size="sm"
    >
      Изменить снова
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'PasswordChangeForm',
  data() {
    return {
      form: {
        current_password: '',
        password: '',
        password_confirmation: '',
      },
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      loading: false,
      passwordChanged: false,
    };
  },

  computed: {
    isFormValid() {
      return this.form.current_password && 
             this.form.password && 
             this.form.password_confirmation &&
             this.form.password === this.form.password_confirmation &&
             this.form.password.length >= 8;
    },
  },

  methods: {
    async onSubmit() {
      if (!this.isFormValid || this.loading) return;

      this.loading = true;

      try {
        const response = await api.call('post', '/api/password/change', this.form);

        if (response.status === 200) {
          this.passwordChanged = true;
          this.$toast.success('Пароль успешно изменен!', {
            position: "top-center",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
            draggable: true,
            draggablePercent: 1,
            showCloseButtonOnHover: true,
            hideProgressBar: true,
            closeButton: "button",
            icon: "fa fa-check-circle",
            rtl: false,
          });
        }
      } catch (error) {
        console.error('Password change error:', error);
        
        let errorMessage = 'Произошла ошибка при изменении пароля. Попробуйте еще раз.';
        
        if (error.response && error.response.data) {
          if (error.response.data.error) {
            errorMessage = error.response.data.error;
          } else if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }

        this.$toast.error(errorMessage, {
          position: "top-center",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: true,
          draggablePercent: 1,
          showCloseButtonOnHover: true,
          hideProgressBar: true,
          closeButton: "button",
          icon: "fa fa-exclamation-triangle",
          rtl: false,
        });
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.form = {
        current_password: '',
        password: '',
        password_confirmation: '',
      };
      this.showCurrentPassword = false;
      this.showNewPassword = false;
      this.showConfirmPassword = false;
      this.passwordChanged = false;
    },

    cancelForm() {
      this.resetForm();
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.form-text {
  font-size: 0.75rem;
  margin-top: 2px;
}
</style>

